import { render } from "./EditPromotion.vue?vue&type=template&id=4e2ad676"
import script from "./EditPromotion.vue?vue&type=script&lang=js"
export * from "./EditPromotion.vue?vue&type=script&lang=js"

import "./EditPromotion.vue?vue&type=style&index=0&id=4e2ad676&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__